// Module
var code = "<div class=\"element-layout -paragraph\"> <div view=\"Html\" data-html=\"[[ text ]]\" class=\"text-style -[[ fontStyle ]]\"></div> </div> ";
// Exports
export default code;